import { MainHeaderApplicationDataProvider } from "@/domain/main-header/application/MainHeaderApplicationData.provider";
import { ScriptSelector } from "@/domain/main-header/entity/ScriptSelector.enum";
import { MenuTitleDTO } from "@/domain/main-header/dto";
import { EventCategoriesConfigurationProvider } from "@/domain/main-header/application/EventCategoriesConfiguration.provider";
import { MenuTitle } from "@/domain/main-header/entity/MenuTitle.interface";
import { MainHeaderTitle } from "@/domain/main-header/entity/MainHeaderTitle.enum";

export class EventsConfigurationProvider {
    public static getConfiguration(): MenuTitle | null {
        const eventTitleData = MainHeaderApplicationDataProvider.hasProvidedDataFor(ScriptSelector.EVENTS) ?
            MainHeaderApplicationDataProvider.parseProvidedData<MenuTitleDTO>(ScriptSelector.EVENTS)
            : null;

        if (!eventTitleData) {
            return null;
        }

        const events = this.normalizeEventSectionData(eventTitleData);
        EventCategoriesConfigurationProvider.provideTo(events);

        return events;
    }

    private static normalizeEventSectionData(data: MenuTitleDTO): MenuTitle {
        return {
            sectionName: MainHeaderTitle.EVENTS,
            name: data.name ?? '',
            title: data.title ?? '',
            url: data.url ?? undefined,
            showChildren: data.showChildren ?? false,
            sectionButton: data.seeAll ?? undefined,
            categories: [],
            promotions: data.promotions ?? [],
        }
    }
}